export enum QUALITY_INDEX_STATUS {
  GOOD = "good",
  WARNING = "warning",
  BAD = "bad",
}

export class AlarmsModel {
  public noSignal?: boolean;
  public noWatermark?: boolean;
  public unexpectedWatermark?: boolean;
  public timestampDrift?: boolean;
  public qualityIndexStatus?: QUALITY_INDEX_STATUS;
}
